import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PLACED_BOXES_FEATURE_KEY } from '../keys';
import { PlacedBoxesState } from '../reducers/placed-boxes.reducer';

const selectState = createFeatureSelector<PlacedBoxesState>(PLACED_BOXES_FEATURE_KEY);

export const selectBoxes = createSelector(selectState, (state: PlacedBoxesState) => state.boxes);
export const selectPage = createSelector(selectState, (state: PlacedBoxesState) => state.page);
export const selectHasMore = createSelector(selectState, (state: PlacedBoxesState) => state.hasMore);
export const selectContents = createSelector(selectState, (state: PlacedBoxesState) => state.contents);
export const selectLockedCode = createSelector(selectState, (state: PlacedBoxesState) => state.lockedCode);
export const selectLoaded = createSelector(selectState, (state: PlacedBoxesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: PlacedBoxesState) => state.loading);
export const selectSaving = createSelector(selectState, (state: PlacedBoxesState) => state.saving);
export const selectSaved = createSelector(selectState, (state: PlacedBoxesState) => state.saved);
